export const getUserRestriction = ({ loginUser, impersonatedUser }) => {
  let {
    assignedDivisions,
    assignedClients,
    assignedLocations,
    assignedSourceSystems,
    assignedProjects,
    assignedContracts,
    assignedFleets,
    assignedAddressTypes,
    assignedScenarios,
    dateFormat,
    dateTimeFormat,
    permissionSet,
    username,
    userGlobalFilterPetroHub,
    isPetroHubUser
  } = loginUser || {};

  let timezone = '';
  if (loginUser.user) {
    timezone = loginUser.user.Timezone;
  }

  if (impersonatedUser) {
    assignedDivisions = impersonatedUser.assignedDivisions;
    assignedClients = impersonatedUser.assignedClients;
    assignedContracts = impersonatedUser.assignedContracts;
    assignedFleets = impersonatedUser.assignedFleets;
    assignedLocations = impersonatedUser.assignedLocations;
    assignedSourceSystems = impersonatedUser.assignedSourceSystems;
    assignedProjects = impersonatedUser.assignedProjects;
    assignedAddressTypes = impersonatedUser.assignedAddressTypes;
    assignedScenarios = impersonatedUser.assignedScenarios;
    dateFormat = impersonatedUser.dateFormat;
    dateTimeFormat = impersonatedUser.dateTimeFormat;
    permissionSet = impersonatedUser.permissionSet;
    username = impersonatedUser.username;
    userGlobalFilterPetroHub = impersonatedUser.userGlobalFilterPetroHub;
    isPetroHubUser = impersonatedUser.isPetroHubUser;

    if (impersonatedUser.user) {
      timezone = impersonatedUser.user.Timezone;
    }
  }

  return {
    permissionSet,
    assignedDivisions,
    assignedClients,
    assignedLocations,
    assignedSourceSystems,
    assignedContracts,
    assignedFleets,
    assignedProjects,
    assignedAddressTypes,
    assignedScenarios,
    dateFormat,
    dateTimeFormat,
    username,
    timezone,
    userGlobalFilterPetroHub,
    isPetroHubUser
  };
};

export const getUserCurrentPageName = () => {
  const pathName = window.location.pathname;
  const pathSegments = pathName.split('/').filter(Boolean);
  return pathSegments.length > 0 ? pathSegments[pathSegments.length - 1] : 'home';
};
